var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.09,
    height: 16.99,
    viewBox: "0 0 59.09 16.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.3,0v5.92c-.53.33,1.12-.59,1.81-.7,9.63-1.46,7.65,15.66-1.68,10.87-.2-.24.01.59-.18.59-1.1,0-3.07-.11-4.25-.1V0h4.3ZM6.36,9.3c-2.64.26-1.6,4.28.73,3.32,1.88-.77.96-3.49-.73-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.01,11.72c.04.56,1.2,1.06,1.74,1.03.77-.04,1.61-1,1.61-1.74v-5.56h4.3v11.13h-3.67c-.21,0,.07-.79-.2-.56-3.08,2.01-7.02.11-7.97-2.58-.24-.7-.33-.92-.35-2.19v-5.79h4.54v6.28-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.87,12.31c.74,2.33,2.4.24,2.51.3.18.11,3.5,1.86,3.71,1.95-4.61,5.49-13.43.92-10.48-6.13,1.79-4.28,8.98-4.47,10.9-.21.29.65,1.03,4.08.18,4.08h-6.82ZM54.26,10.18c.18-1.75-2.16-2.07-2.39-.35-.06.45,0,.34.36.36.68.03,1.36-.02,2.04,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.69,12.26c1.04,1.09,2.64.26,2.8.17.15-.09,2.23,2.17,2.41,2.37.63.72-.98,1.5-1.62,1.73-2.91,1.07-6.22.11-7.68-2.72-2.69-5.21,2.64-10.43,7.94-8.1.29.13,1.29.77,1.47.91.32.25.28.19-.12.6-.2.2-2.26,2.47-2.41,2.37-.96-.63-1.77-.73-2.76.33-.56.61-.6,1.74-.04,2.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.62,5.8c1.91.03,3.24-.01,3.72-.01.08,0-.05.44.09.46l.36-.32c1.31-.9,2.67-.75,4.19-.72-.15.31-.83,4.06-1.07,4.03-.79-.12-1.58-.41-1.89-.21-1.15.75-1.1,1.37-1.1,1.98v5.56h-4.3s0-10.77,0-10.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.f0f3781461014f6ef5d0f09142f83986.svg";
export { ForwardRef as ReactComponent };